import isMobile from "@src/utils/isMobile";

export const useTeacherSignupMobileRedesign = () => {
  // this used to include experimentation logic, but now is just a wrapper around isMobile().phone.
  // it at least centralizes mobile detection, in case we ever want to change it (e.g. react-responsive media queries)
  return isMobile().phone;
};
